import React, { memo } from "react";
import NodeWrapper from "./NodeWrapper";
import { LocationOn } from "@mui/icons-material";

/**
 * Send Location — Enviar localizacao no WhatsApp.
 *
 * data.latitude: string/number
 * data.longitude: string/number
 * data.locationName: string — nome do local (opcional)
 * data.locationAddress: string — endereco (opcional)
 *
 * Saida: handle "a" (default)
 */
const SendLocationNode = memo(({ id, data, isConnectable, selected }) => {
  const lat = data?.latitude || "";
  const lng = data?.longitude || "";
  const name = data?.locationName || "";

  return (
    <NodeWrapper
      id={id}
      data={data}
      icon={<LocationOn />}
      title="Enviar Localizacao"
      color="#C62828"
      bgColor="#FFEBEE"
      isConnectable={isConnectable}
      selected={selected}
      minWidth={200}
    >
      {name ? (
        <div style={{
          fontSize: 12, fontWeight: 600, color: "#C62828",
          marginBottom: 4,
        }}>
          {name}
        </div>
      ) : null}
      <div style={{
        background: "#fff",
        border: "1px solid #e0e0e0",
        borderRadius: 6,
        padding: "4px 10px",
        fontSize: 11,
        fontFamily: "'Fira Code', monospace",
        color: "#555",
      }}>
        {lat && lng
          ? `${lat}, ${lng}`
          : "Coordenadas nao definidas"
        }
      </div>
    </NodeWrapper>
  );
});

SendLocationNode.displayName = "SendLocationNode";
export default SendLocationNode;
